import { useEffect, useState } from 'react';

export const useComponentLoaded = () => {
  const [componentLoaded, setComponentLoaded] = useState(false);
  useEffect(() => {
    setComponentLoaded(true);
  }, [setComponentLoaded]);
  return componentLoaded;
};
